import {type RankedModeTypes} from '../../../../shared/GameEnums.ts'
import {LeaderboardConstants} from '../../../../shared/leaderboard_data/LeaderboardConstants.ts'
import {UIWLeaderboardController} from './UIWLeaderboardController.ts'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup.ts'
import {UIProfileSettingsRegionChangeController} from '../../../shared/scripts/profile/UIProfileSettingsRegionChangeController.ts'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper.ts'
import {ClientUserState} from '../../../shared/scripts/ClientUserState.ts'
import {UIDLeaderboardCTAController} from './UIDLeaderboardCTAController.ts'

export class UIDLeaderboardController extends UIWLeaderboardController {
    protected initCTAController() {
        this.ctaController = new UIDLeaderboardCTAController()
    }

    async fetchStickyRowData() {
        void this.fetchMyStickyRowData()
    }

    protected override async onRankedModeChange(rankedMode: RankedModeTypes) {
        this.switchRankingCategoryTypeData(rankedMode, this.leaderboardUrl, this.searchTerm)
        await this.fetchMyStickyRowData()
        this.showChangeRegionIncentivePopup()
    }

    protected override initiateParametersFromUrl() {
        this.leaderboardUrl = LeaderboardConstants.globalLeaderboardUrl
        this.searchTerm = ''
    }

    showChangeRegionIncentivePopup() {
        const alreadyShown = StorageWrapper.getDiscordChangeRegionIncentivePopupShown()
        if(alreadyShown) return

        const isRanked = this.stickyRowController.isRanked
        if(!isRanked) return

        const changedRegionManually = ClientUserState.userState?.regionUpdated != undefined
        if(changedRegionManually) return

        const popup = new ViewPopup({key: 'strings:popups.changeRegionIncentive.title'},
            {key: 'strings:popups.changeRegionIncentive.body'},
            () => UIProfileSettingsRegionChangeController.showChangeRegionPopup(),
            () => undefined,
            true)
        popup.removeXButton()
        popup.show()
        StorageWrapper.setDiscordChangeRegionIncentivePopupShown()
    }
}
